<section class="brand-group" aria-label="Brand section">
  <cwc-button variant="link" color="bright-blue" leading-icon="arrow-left-single" (click)="onBack()">Back</cwc-button>
  <img class="brand-group__logo" src="assets/certify/Arkik-AI-logo.svg" alt="Arkik AI" />
  <span class="brand-group__title">Talk to your data</span>
</section>
